import React from 'react';
import moment from 'moment';
import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import numeral from 'numeral';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Header from 'components/Header';

export default class LoanSchedule extends React.Component {
  totality = () => {
    let totalInterest = 0.0;
    let totalPayable = 0.0;
    Object
      .keys(this.props.schedules).forEach(key => {
        totalPayable += this.props.schedules[key].totalPayable;
        totalInterest += this.props.schedules[key].interest;
      });
    return { totalPayable, totalInterest };
  }

  renderMetadata = () => {
    return (
      <div>
        <div>
          <Header heading='Schedules' />
          <Divider light />
        </div>
        <List>
          <ListItem>
            <ListItemText primary={ `Total interest: ${numeral(this.totality().totalInterest).format('$0,0.00')}` } />
          </ListItem>
          <ListItem>
            <ListItemText primary={ `Total payable: ${numeral(this.totality().totalPayable).format('$0,0.00')}` }/>
          </ListItem>
        </List>
      </div>
    )
  }

  renderSchedule = (key, schedule) => {
    const repaymentDate = moment(schedule.repaymentDatetime, 'YYYY-MM-DD').format('YYYY-MM-DD');
    return (
      <TableRow key={key}>
        <TableCell>
          {repaymentDate}
        </TableCell>
        <TableCell>
          {schedule.days}
        </TableCell>
        <TableCell>
          <strong>{numeral(schedule.totalPayable).format('$0,0.00')}</strong>
        </TableCell>
        <TableCell>
          {numeral(schedule.principal).format('$0,0.00')}
        </TableCell>
        <TableCell>
          {numeral(schedule.interest).format('$0,0.00')}
        </TableCell>
        <TableCell>
          {numeral(schedule.establishmentFee).format('$0,0.00')}
        </TableCell>
      </TableRow>
    );
  }

  renderSchedules = () => {
    return Object
      .keys(this.props.schedules)
      .map(key => this.renderSchedule(key, this.props.schedules[key]));
  }

  render() {
    if (this.props.quote && this.props.schedules) {
      return (
        <div>
          { this.renderMetadata() }
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Repayment date</TableCell>
                <TableCell>Days</TableCell>
                <TableCell>Total payable</TableCell>
                <TableCell>Principal</TableCell>
                <TableCell>Interest</TableCell>
                <TableCell>Establishment</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {this.renderSchedules()}
            </TableBody>
          </Table>
        </div>
      );
    }
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/Applications/LoanSchedule.js